import { IMenuConfiguration } from "./IMenuConfiguration";
import dnevnaTablaIcon from "../images/dnevna-tabla.png";
import statistikeIcon from "../images/statistike.png";
import javneNabavkeIcon from "../images/javne-nabavke.png";
import garancijeIcon from "../images/garancije.png";
import projektiIcon from "../images/projekti.png";
import karnetiIcon from "../images/karneti.png";
import incidentiIcon from "../images/incidenti.png";
import ljudskiResursiIcon from "../images/ljudski-resursi.png";
import saradniciIcon from "../images/saradnici.png";
import resursiIcon from "../images/resursi.png";
import potrosniMaterijaliIcon from "../images/potrosni-materijali.png";
import lagerIcon from "../images/lager.png";
import betonskaBazaIcon from "../images/betonska-baza.png";
import asfaltnaBazaIcon from "../images/asvaltna-baza.png";
import chatIcon from "../images/chat.png";
import trebovanjaIcon from "../images/trebovanja.png";
import izvestajiIcon from "../images/izvestaji.png";
import { RESOURCES_MODULE_NAME } from "Dashboard/scenes/Resources/domain/ResourcesModule";
import { CONSUMABLES_MODULE_NAME } from "Dashboard/scenes/Consumables/domain/ConsumablesModule";
import { STOCK_MODULE_NAME } from "Dashboard/scenes/Stock/domain/StockModule";
import { CONCRETE_BASE_MODULE_NAME } from "Dashboard/scenes/ConcreteBase/domain/ConcreteBaseModule";
import { CARNET_MODULE_NAME } from "Dashboard/scenes/Carnets/domain/CarnetModule";
import { HUMAN_RESOURCES_MODULE_NAME } from "Dashboard/scenes/HumanResources/domain/HumanResourcesModule";
import { PARTNER_MODULE_NAME } from "Dashboard/scenes/Partners/domain/PartnerModule";
import { INCIDENT_MODULE_NAME } from "Dashboard/scenes/Incidents/domain/IncidentModule";
import { PROJECT_MODULE_NAME } from "Dashboard/scenes/Projects/domain/ProjectModule";
import { REQUISITION_WAREHOUSE_MODULE_NAME } from "Dashboard/scenes/Requisitions/domain/RequisitionsModule";

export const MenuConfiguration: IMenuConfiguration = {
  group1: [
    {
      menuItemId: "dashboardMenuItem11",
      title: "Dnevna tabla",
      path: "/daily-table",
      icon: dnevnaTablaIcon,
      module: "daily-table",
    },
    {
      menuItemId: "dashboardMenuItem12",
      title: "Statistke",
      path: "/statistics",
      icon: statistikeIcon,
      module: "statistics",
    },
  ],
  group2: [
    {
      menuItemId: "dashboardMenuItem21",
      title: "Javne nabavke",
      path: "/javne-nabavke",
      icon: javneNabavkeIcon,
      module: "javne nabavke",
    },
    {
      menuItemId: "dashboardMenuItem22",
      title: "Garancije",
      path: "/garancije",
      icon: garancijeIcon,
      module: "garancije",
    },
    {
      menuItemId: "dashboardMenuItem23",
      title: "Gradnja - prodaja",
      path: "/high-rise-sales",
      icon: projektiIcon,
      module: "high-rise-sales",
    },
    {
      menuItemId: "dashboardMenuItem24",
      title: "Projekti",
      path: "/projects",
      icon: projektiIcon,
      module: PROJECT_MODULE_NAME,
    },
  ],
  group3: [
    {
      menuItemId: "dashboardMenuItem31",
      title: "Karneti - HTZ",
      path: "/carnets",
      icon: karnetiIcon,
      module: CARNET_MODULE_NAME,
    },
    {
      menuItemId: "dashboardMenuItem32",
      title: "Bonusi / kazne",
      path: "/incidents",
      icon: incidentiIcon,
      module: INCIDENT_MODULE_NAME,
    },
    {
      menuItemId: "dashboardMenuItem33",
      title: "Ljudski resursi",
      path: "/human-resources",
      icon: ljudskiResursiIcon,
      module: HUMAN_RESOURCES_MODULE_NAME,
    },
    {
      menuItemId: "dashboardMenuItem34",
      title: "Saradnici",
      path: "/partners",
      icon: saradniciIcon,
      module: PARTNER_MODULE_NAME,
    },
  ],
  group4: [
    {
      menuItemId: "dashboardMenuItem41",
      title: "Resursi",
      path: "/resources",
      icon: resursiIcon,
      module: RESOURCES_MODULE_NAME,
    },
    {
      menuItemId: "dashboardMenuItem42",
      title: "Potrošni materijali",
      path: "/consumables",
      icon: potrosniMaterijaliIcon,
      module: CONSUMABLES_MODULE_NAME,
    },
    {
      menuItemId: "dashboardMenuItem43",
      title: "Lager",
      path: "/stock",
      icon: lagerIcon,
      module: STOCK_MODULE_NAME,
    },
    {
      menuItemId: "dashboardMenuItem44",
      title: "Betonska baza",
      path: "/betonska-baza",
      icon: betonskaBazaIcon,
      module: CONCRETE_BASE_MODULE_NAME,
    },
    {
      menuItemId: "dashboardMenuItem45",
      title: "Asfaltna baza",
      path: "/asfaltna-baza",
      icon: asfaltnaBazaIcon,
      module: "asfaltna-baza",
    },
  ],
  group5: [
    {
      menuItemId: "dashboardMenuItem51",
      title: "Chat",
      path: "/chat",
      icon: chatIcon,
      module: "chat",
    },
    {
      menuItemId: "dashboardMenuItem52",
      title: "Trebovanja - magacin",
      path: "/trebovanja",
      icon: trebovanjaIcon,
      module: REQUISITION_WAREHOUSE_MODULE_NAME,
    },
    {
      menuItemId: "dashboardMenuItem53",
      title: "Izveštaji",
      path: "/reports",
      icon: izvestajiIcon,
      module: "report",
    },
  ],
};
